export default __webpack_public_path__ + "static/media/telegram-black.142154fa.svg";